import idPrereservations from "./IDPreReservationReducer";

const idPrereservation = {
    reducers: idPrereservations
}

export default idPrereservation;